import { LoginComponent } from "./login/login.component";
import { GuestGuard } from "../../shared/_guards/guest.guard";

export const LOGIN_ROUTES = [
  { path: "", component: LoginComponent, canActivate: [GuestGuard] },
];

export const loginComponents = [LoginComponent];
